import React, { useState } from "react";
import { getCardImage } from "../../resultVisuals/cardAssets";
import FlipCard from "./FlipCard";

/**
 * Generic reference card overlay for VideoBox (Cricket Match 20-20, 1 Card Meter, 20-20 D T L):
 *   .casino-video-cards[.hide-cards] > .casino-cards-shuffle + .casino-video-cards-container
 *     > (count cards as <span><img></span>, wrapped in a <div> when `wrap`)
 * Like the reference: hidden while the first card is a back ("1"); the shuffle handle toggles it.
 */
export default function RefCardsOverlay({ card, count = 1, wrap = false }) {
  const [showCards, setShowCards] = useState(true);
  if (card == null) return null;
  const cards = String(card).split(",").map((c) => c.trim());
  const hidden = !showCards || cards[0] === "1";
  if (cards[0] === "1" && !showCards) setShowCards(true); // new round re-opens a hand-closed strip
  const items = Array.from({ length: count }, (_, i) => (
    <React.Fragment key={i}>
      {i > 0 && " "}
      <span>
        <FlipCard src={getCardImage(cards[i])} alt="" />
      </span>
    </React.Fragment>
  ));

  return (
    <div className={`casino-video-cards${hidden ? " hide-cards" : ""}`}>
      <div className="casino-cards-shuffle" onClick={() => cards[0] !== "1" && setShowCards((v) => !v)}>
        <i className="fas fa-grip-lines-vertical" />
      </div>{" "}
      <div className="casino-video-cards-container">{wrap ? <div>{items}</div> : items}</div>
    </div>
  );
}
